import React from 'react';
import { connect } from 'react-redux';

import { Logo } from 'src/common/components/logo';
import Recover from 'src/user-authentication/recover';

const LogIn = ({ params, location }) => (
  <div style={{ minHeight: '100vh' }}>
    <div className="app-nav">
      <nav className="navbar navbar-full">
        <a href="/" key="logo">
          <Logo type="black" />
        </a>
      </nav>
    </div>
    <Recover viewParams={{ ...params, query: location.query }} />
  </div>
);

export default connect()(LogIn);
